import DropArea from '@src/components/DropArea';
import useAttachFilesSummary from '@src/hooks/useAttachFilesSummary';
import { MediaType } from '@src/model/frontendmodel';
import {
  isChatComposerDisabled,
  isTransferInProgress,
} from '@src/selectors/agentConsole';
import { activeChatSelector } from '@src/selectors/chats';
import { RootState } from '@src/store/reduxstore';
import mediaUtils from '@src/utils/mediaUtils';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import attachFilesUtil from '../ComposerToolbar/FileUtils';

const ConsoleDropArea: React.FC = () => {
  const { formatMessage } = useIntl();

  const { isAttachFilesSummaryEnabled } = useAttachFilesSummary();

  const chatComposerDisabled = useSelector(isChatComposerDisabled);
  const activeChat = useSelector(activeChatSelector);
  const isFileSubmissionEnabled = useSelector(
    (state: RootState) => state.generalProperties.isFileSubmissionEnabled
  );
  const transferInProgress = useSelector(isTransferInProgress);

  return (
    <DropArea
      target="#chatbox"
      enabled={
        !chatComposerDisabled &&
        !transferInProgress &&
        isFileSubmissionEnabled &&
        activeChat?.provider &&
        (mediaUtils.isMediaTypeSupported(MediaType.FILE, activeChat.provider) ||
          mediaUtils.isMediaTypeSupported(
            MediaType.IMAGE,
            activeChat?.provider
          ))
      }
      filterFile={() => true}
      onDrop={(files: File[]) =>
        attachFilesUtil({
          files,
          activeChat,
          formatMessage,
          isAttachFilesSummaryEnabled,
        })
      }
    />
  );
};

export default ConsoleDropArea;
